module.exports = __webpack_public_path__ + "static/media/autumn_small.dbf4e3a5.jpg";